import React, { useContext, useState } from 'react'
import { plannerClient } from '.'
import { useQuery } from '@apollo/client'
import { GET_ROOMS } from '../queries'

const RoomOptionContext = React.createContext()

function RoomOptionProvider({ children }) {
  const [loc, setLocation] = useState('all')
  const [group, setGroup] = useState(undefined)
  const { loading, data, refetch } = useQuery(GET_ROOMS, {
    variables: {
      ...(loc && { loc }),
      ...(group && { group }),
    },
  })
  const { rooms } = data || {}

  function updateRooms(changeRoom, type) {
    let cached = plannerClient.readQuery({
      query: GET_ROOMS,
      variables: {
        loc: 'all',
        group: undefined,
      },
    })

    let _rooms = cached.rooms
    switch (type) {
      case 'create':
        _rooms = [...cached.rooms, changeRoom].sort(function (a, b) {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })
        break
      case 'update':
        _rooms = cached.rooms
          .map((room) => {
            if (room.room_id === changeRoom.room_id) {
              return changeRoom
            }
            return room
          })
          .sort(function (a, b) {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          })
        break
      case 'remove':
        _rooms = cached.rooms.filter(
          (room) => room.room_id !== changeRoom.room_id,
        )
        break
      default:
    }
    plannerClient.cache.writeQuery({
      query: GET_ROOMS,
      variables: {
        loc: 'all',
        group: undefined,
      },
      data: {
        rooms: _rooms,
      },
    })
  }

  return (
    <RoomOptionContext.Provider
      value={{
        loading,
        rooms,
        refetch,
        setLocation,
        setGroup,
        updateRooms,
      }}
    >
      {children}
    </RoomOptionContext.Provider>
  )
}

function useRoomOptions() {
  return useContext(RoomOptionContext)
}

export { RoomOptionProvider, useRoomOptions }
